import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { UiService } from '@shared/services/ui.service';
import { map } from 'rxjs';
import { AuthApiService } from '../services/auth-api.service';
import {AuthStore} from "@features/auth/auth.store";
import {AuthStatus} from "../models/models";

export const authGuard: CanMatchFn = () => {
  const authStore = inject(AuthStore);
  const authApiService = inject(AuthApiService);
  const uiService = inject(UiService);
  const router = inject(Router);

  if (authStore.authStatus() === AuthStatus.pending) {
    if (authStore.token()) {
      return authApiService.getAuthorization().pipe(
        map(response => {
          if (response.ok) {
            authStore.setAuthStatus(AuthStatus.passes);
            router.navigateByUrl('/dashboard');
          } else {
            authStore.logout(false);
          }
          uiService.stopLoading();
          return !response.ok;
        })
      );
    } else {
      authStore.logout(false);
      uiService.stopLoading();
      return true;
    }
  } else if (authStore.authStatus() === AuthStatus.passes) {
    router.navigateByUrl('/dashboard');
    return false;
  } else {
    return true;
  }
};
